import { node, string, oneOfType, func, object, bool } from "prop-types";
import cx from "classnames";
import * as R from "ramda";

const propTypes = {
  children: node,
  className: string,
  icon: node,
  isSquare: bool,
  hoverIcon: node,
  as: oneOfType([string, func, object]),
};

const defaultProps = {
  // can use "as" prop to make this button a link
  // eg <Button as="a" href="#some-link" className="btn--primary">
  as: "button",
};

const Button = (props) => {
  const {
    children,
    className,
    icon,
    isSquare,
    hoverIcon,
    as: Component,
    ...otherProps
  } = props;
  const hasHoverIcon = !R.isNil(hoverIcon);

  return (
    <Component
      className={cx("btn", className, {
        "btn--has-hover-icon": hasHoverIcon,
        "btn--square": isSquare,
      })}
      {...otherProps}
    >
      {children}
      {icon && <span className="btn__icon">{icon}</span>}
      {hasHoverIcon && <span className="btn__icon--hover">{hoverIcon}</span>}
    </Component>
  );
};

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
export default Button;
